import { render, staticRenderFns } from "./LayoutLegal.vue?vue&type=template&id=2a100f31&scoped=true"
import script from "./LayoutLegal.vue?vue&type=script&lang=js"
export * from "./LayoutLegal.vue?vue&type=script&lang=js"
import style0 from "./LayoutLegal.vue?vue&type=style&index=0&id=2a100f31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a100f31",
  null
  
)

export default component.exports